<template>
    <div class="top-btn-container">
        <a href="#" v-scroll-to="{el: '#app', offset: 0}" class="top-btn">
            <div class="in"><svgIcon name="arrow-top" class="icon-arrow-top"/></div>
            <!-- <small>вверх</small> -->
        </a>
    </div>  
</template>


<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'secret-btns',
        components: {
            svgIcon,
        },
        data () {
            return {
                
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/partials/top-btn.scss';
</style>